import { render, staticRenderFns } from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop.html?vue&type=template&id=2fdba174&scoped=true&"
import script from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop.css?vue&type=style&index=0&id=2fdba174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdba174",
  null
  
)

export default component.exports